"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M6.35356 14.3531L4.35356 16.3531C4.25556 16.4511 4.12756 16.4991 3.99956 16.4991C3.87256 16.4991 3.74456 16.4511 3.64656 16.3531C3.45156 16.1581 3.45156 15.8411 3.64656 15.6461L5.64656 13.6461C5.84156 13.4511 6.15856 13.4511 6.35356 13.6461C6.54856 13.8411 6.54856 14.1581 6.35356 14.3531ZM17.7906 5.20907L14.2546 8.74507C14.1026 8.89707 13.8706 8.93507 13.6776 8.83807L12.1496 8.07407C12.0526 8.02607 11.9736 7.94707 11.9256 7.85007L11.1616 6.32207C11.0646 6.12907 11.1026 5.89707 11.2546 5.74507L14.7866 2.21307C14.0896 1.99507 13.3226 1.93407 12.5276 2.07907C10.5116 2.44307 8.93856 4.19507 8.80156 6.22407C8.76856 6.71007 8.80456 7.18907 8.91056 7.63907C8.94956 7.80607 8.90856 7.97807 8.78856 8.10107L2.14456 14.8531C2.05156 14.9471 1.99956 15.0741 2.00056 15.2061L2.00556 16.8891C1.94056 17.4811 2.40756 17.9991 3.00756 17.9991H4.79256C4.92556 17.9991 5.05256 17.9471 5.14656 17.8531L11.8556 11.1481C11.9776 11.0261 12.1506 10.9841 12.3186 11.0231C12.7706 11.1271 13.2506 11.1631 13.7406 11.1311C15.7836 10.9971 17.5496 9.43807 17.9196 7.43807C18.0646 6.65407 18.0056 5.89707 17.7906 5.20907Z",
    fill: "#727B7F"
  }));
};